const { $userInfo, $BusinessToken, $PAGE_HOST, $systemType } = window.React;
export const userInfo = $userInfo || {
    "sysUserId": "402880407f731b85017f731b8acb0008",
    "sysUserCode": "18850558605",
    "sysUserName": "郑章鸿",
    "sysOrgCode": "A01A02A01"
};
export const token = $BusinessToken;
export const pageUrl = $PAGE_HOST;
export const systemType = $systemType;
